import React from 'react';
import styled from 'styled-components';
import {COLORS, FONTS, SIZES, Typography, Image} from '@fupa/fupa-uikit';
import {Block} from '@mui/icons-material';
import {Button} from '@mui/material';

const OverlayContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.black};
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: blur(20px);
`;

const Content = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SIZES['16']};
`;

const ConsentPlaceholder = styled.div`
  height: 100%;
  width: 100%;
  max-width: ${props => props.theme.desktopContentWidth}px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  padding: ${SIZES['16']};
  ${props => props.theme.desktopLayout`
     padding: ${SIZES['32']};
  `};
`;

const ConsentTypography = styled(Typography)`
  &&& {
    font-size: ${FONTS['16']};
    ${props => props.theme.desktopLayout`
      font-size: ${FONTS['20']};
    `};
  }
`;

const StyledBlock = styled(Block)`
  &&& {
    color: white;
    font-size: ${SIZES['84']};
  }
`;

export const VideoBlocked = ({video}) => {
  const openConsent = e => {
    e.stopPropagation();
    __cmp('showScreen');
  };

  return (
    <OverlayContainer>
      <ImageContainer>
        <Image src={video?.thumbnail} entity='video' width='100%' height='auto' />
      </ImageContainer>
      <Content>
        <ConsentPlaceholder>
          <StyledBlock />
          <ConsentTypography variant='title1'>
            Die Bereitstellung von Video-Inhalten ist sehr kostenintensiv und refinanziert sich mit Video-Werbung. Um
            Video-Inhalte ansehen zu können, müssen deshalb die Cookie-Richtlinien akzeptiert werden.
          </ConsentTypography>
          <ActionContainer>
            <Button color='secondary' variant='contained' onClick={openConsent}>
              Cookie-Richtlinien öffnen
            </Button>
            <Button variant='text' sx={{color: COLORS.white}} component='a' href={`/match/${video?.match?.slug}`}>
              Zum Spiel
            </Button>
          </ActionContainer>
        </ConsentPlaceholder>
      </Content>
    </OverlayContainer>
  );
};
